import React from 'react';
import parse from 'html-react-parser';
import Carousel from 'react-material-ui-carousel';
import Container from '@material-ui/core/Container';
import {
  authorCss,
  carouselBoxCss,
  quotesCss,
} from 'app/modules/web-shop/sub-modules/landing-module/components/testimonials-block/style';
import { ReactComponent as LeftQuote } from 'app/modules/web-shop/sub-modules/landing-module/components/testimonials-block/QuoteLeft.svg';
import {
  TestimonialsData,
  TestimonialsDataProps,
} from 'app/modules/web-shop/sub-modules/landing-module/components/testimonials-block/data';

export function Testimonials() {
  return (
    <Container css="margin-bottom: 5rem;">
      <h3 css="margin: 5rem 0 2rem 0; font-size:36px; ">
        Why organisations choose AIDA
      </h3>
      <Carousel
        swipe
        autoPlay
        interval={5000}
        animation="slide"
        stopAutoPlayOnHover
        activeIndicatorIconButtonProps={{
          style: {
            color: '#2E4063',
          },
        }}
        indicatorContainerProps={{
          style: {
            marginTop: '100px',
          },
        }}
        indicatorIconButtonProps={{
          style: {
            color: '#A1AEBD',
          },
        }}
      >
        {TestimonialsData.map((testimonial: TestimonialsDataProps) => (
          <Container maxWidth="lg" key={testimonial.title} css={carouselBoxCss}>
            <LeftQuote css={quotesCss} />
            {parse(testimonial.title as string)}
            {parse(testimonial.body as string)}
            <div css={authorCss}>
              {parse(testimonial.companyLogo as string)}
              <div css="margin-left: 1rem;">
                {parse(testimonial.authorName as string)}
                {parse(testimonial.authorRole as string)}
              </div>
            </div>
          </Container>
        ))}
      </Carousel>
    </Container>
  );
}
